<template>
  <v-app>
    <nav-draw v-if="getLoggedIn" v-model="drawer"></nav-draw>

    <v-app-bar v-if="!loadingapp" :class="primaryBg" app dark color="primary">
      <v-app-bar-nav-icon @click="drawer = !drawer" v-if="getLoggedIn"></v-app-bar-nav-icon>
      <span v-if="$vuetify.breakpoint.xsOnly" style="display: inline-block"></span>
      <span v-else style="display: inline-block; width: 50px"></span>
      <v-img max-width="184" max-height="43" width="184" height="43" aspect-ratio="1"  src="img/prysmian_logo_new.png" @click="logoClick" :class="getLoggedIn ? 'clickable' : ''"></v-img>
      <span v-if="$vuetify.breakpoint.xsOnly">
        <v-divider class="mx-2" inset vertical white></v-divider>
      </span>
      <span v-else> <v-divider class="mx-5" inset vertical white></v-divider></span>
      <v-toolbar-title class="headline">
        <!-- <span class="text-uppercase">{{ $t("common.app.name") }}</span> -->
        <span v-if="$vuetify.breakpoint.xsOnly">{{ $t("common.appname") }}</span>
        <span v-else class="text">{{ $t("common.dailyprogressreport") }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn tile elevation="0" class="text-none" color="primary">
        <b-icon icon="question-circle-fill"></b-icon>
        <span v-if="$vuetify.breakpoint.xsOnly"></span>
        <span v-else style="margin-left: 5px">{{ $t("common.onlinemanuals") }}</span>
      </v-btn>
      <v-btn tile elevation="0" class="text-none" color="primary" :to="{ name: 'userprofile' }" v-if="getLoggedIn">
        <b-icon icon="person-fill"></b-icon>
        <span v-if="$vuetify.breakpoint.xsOnly"></span>
        <span v-else style="margin-left: 5px">{{ $t("common.nav.myprofile") }}</span>
      </v-btn>

      <!-- <v-btn text v-if="getLoggedIn" @click="doLogout">
        <v-icon left>logout</v-icon>
        <span class="mr-2">{{ $t("common.logout") }}</span>
      </v-btn> -->
    </v-app-bar>

    <v-main v-if="!loadingapp" :class="background">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-snackbar v-model="showErrorSnackbar" top color="error" :timeout="5000">
      {{ getErrorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="showErrorSnackbar = false">{{ $t("common.close") }}</v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="showInfoSnackbar" top color="info" :timeout="5000">
      {{ getInfoMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="showInfoSnackbar = false">{{ $t("common.close") }}</v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="getLongLoader.show" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="loadingtext">
          {{ getLongLoaderMessage }}
          <v-progress-linear indeterminate color="white" height="5" class="mt-1 mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="loadingdiv" v-if="loadingapp">
      <v-layout row justify-center>
        <v-dialog v-model="loadingapp" hide-overlay persistent content content-class="centered-dialog">
          <v-container fill-height>
            <v-layout column justify-center align-center>
              <h1 class="pb-3">Loading application</h1>
              <v-progress-circular indeterminate :size="50" :width="7" color="primary"></v-progress-circular>
              <h3 class="pt-3">Please wait...</h3>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </div>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NavDraw from "./components/NavDraw.vue";

export default {
  name: "hqapp",
  components: {
    "nav-draw": NavDraw,
  },
  data() {
    return {
      showErrorSnackbar: false,
      showInfoSnackbar: false,
      drawer: false,
    };
  },
  computed: {
    ...mapGetters(["getLoadingApp", "getLoggedIn", "getErrorMessage", "getInfoMessage", "getLongLoader", "getLongLoaderMessage"]),
    primaryBg() {
      if (!this.getLoggedIn) return null;
      return "primary";
    },
    loadingapp() {
      return this.getLoadingApp;
    },
    background() {
      if (this.getLoggedIn) return null;
      return "bgimg";
    },
  },
  watch: {
    getErrorMessage() {
      this.showErrorSnackbar = this.getErrorMessage !== "";
    },
    getInfoMessage() {
      this.showInfoSnackbar = this.getInfoMessage !== "";
    },
    getLoggedIn(value) {
      if (!value) this.$router.push({ name: "login" });
    },
  },

  methods: {
    ...mapActions(["doLogout", "m_project/fetchProjectNames", "m_vessel/fetchVesselNames"]),
    logoClick() {
      this.$router.push({ name: "home" });
    },
  },

  created() {
    //   this['m_project/fetchProjectNames']()
    //   this['m_vessel/fetchVesselNames']()
  },

  mounted() {
    if (this.$TARGET === "development") console.log("Development build");
    if (this.$TARGET === "production") console.log("Production build");
  },
};
</script>

<style>
#pCardAct {
  margin-top: -55px;
  padding: 15px;
}
.v-input__slot {
  align-items: center;
  justify-content: center;
}
table td + td {
  border-left: none;
}
table th + th {
  border-left: none;
}
.v-container {
  max-width: 90%;
}
.loadingdiv {
  height: 100vh;
  width: 100vw;
  background: #e7e8ea;
}

.bgimg {
  background-image: url("/img/loginbg.jpg");
  background-size: cover;
}

.dialog.centered-dialog,
.v-dialog.centered-dialog {
  background: white;
  box-shadow: none;
  border-radius: 6px;
  width: auto;
  color: #556689;
  border: 3px solid#556689;
}

.whitecontainer {
  background-color: white;
}
.toprightdiv {
  position: absolute !important;
  top: 15px !important;
  right: 15px !important;
}
.topleftdiv {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
}
.bottomleftdiv {
  position: absolute !important;
  bottom: 0px !important;
  left: 0px !important;
}
.silentlink {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.silentlink:hover {
  color: #000;
  text-decoration: underline;
}
.v-table__overflow {
  overflow-x: hidden;
}
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px;
}

.topleftcorner {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
}
.toprightcorner {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
}

.text-h5 {
  padding-left: 5px;
}
.v-btn {
  font-weight: 400;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  white-space: nowrap;
  font-size: 13px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 13px;
}

.v-main__wrap > div {
  height: 95%;
}
.fullh {
  height: 100%;
}
.nfullh {
  height: 90%;
}

.context {
  padding-left: 0px !important;
}

.loadingtext {
  font-size: 16px;
}

.clickable {
  cursor: pointer;
}
.sort-asc-sign {
  background: #e9ecef !important;
  background-image: none !important;
}
.sort-des-sign {
  background: #e9ecef !important;
  background-image: none !important;
}
</style>
